var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.25,
    height: 27,
    viewBox: "0 0 20.25 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags_1_",
    "data-name": "flags (1)",
    transform: "translate(-63.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16961",
    "data-name": "Group 16961",
    transform: "translate(63.998)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12024",
    "data-name": "Path 12024",
    d: "M83.8,3.263a.783.783,0,0,0-.787,0,6.273,6.273,0,0,1-3.082.787A5.877,5.877,0,0,1,75.7,2.385,6.786,6.786,0,0,0,70.807.45,7.047,7.047,0,0,0,66.7,1.728V1.35a1.35,1.35,0,1,0-2.7,0v24.3a1.35,1.35,0,1,0,2.7,0V13.95a.787.787,0,0,0,.409-.162,6.1,6.1,0,0,1,3.7-1.188,5.886,5.886,0,0,1,4.239,1.665A6.782,6.782,0,0,0,79.928,16.2a7.033,7.033,0,0,0,3.933-1.148.9.9,0,0,0,.387-.765V4.05A.9.9,0,0,0,83.8,3.263Z",
    transform: "translate(-63.998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagicon);
export default __webpack_public_path__ + "static/media/flag icon.470c1ffd4a9f1c7b77a4b8a3b219ec82.svg";
export { ForwardRef as ReactComponent };